module.exports = __webpack_public_path__ + "img/20180815_152858_229.bb189f6e.jpg";